module.exports = __webpack_public_path__ + "img/block4.7bdb6e21.png";